import {observer} from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import {useEffect} from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import ExchangeOrderInvoiceEditor from "./exchange-order-invoice-editor";
import {EXCHANGE_ORDER_INVOICE_SCOPE} from "./constants";
import emailContentListStore from "../../../../stores/email-content-list-store";

const ExchangeOrderInvoiceEditorPage: React.FC = observer(() => {
    const {setSubTitles} = usePage();

    useEffect(() => {
        setSubTitles(['Content', 'Exchange Fees Draft Order']);
        emailContentListStore.onShowTranslationButton(false);
    }, [setSubTitles]);

    const {selectedLocale} = useTranslation();

    return (
        <TranslationScope scope={EXCHANGE_ORDER_INVOICE_SCOPE} locale={selectedLocale}>
            <ExchangeOrderInvoiceEditor/>
        </TranslationScope>
    );
});

export default ExchangeOrderInvoiceEditorPage;